import TableFailedTransactions from './component/TableFailedTransactions'

export default TableFailedTransactions